import * as tslib_1 from "tslib";
import React from 'react';
import classnames from 'classnames';
import numeral from 'numeral';
import onClickOutside from 'react-onclickoutside';
import { withTranslation } from 'react-i18next';
import { IconSize } from '../../../Icons/IconWrap';
import UserAvatar from '../../../User/Avatar';
import UserIcon from '../../../Icons/User';
import CoreIconSmall from '../../../Icons/CoreIconSmall';
import Dino from '../../../Icons/Dino';
import StandardMenu from '../../../Dropdown/Preset/StandardMenu';
import { URLS } from '@wix/da-url/dist/src/constants';
import { Url } from '@wix/da-url';
import MatureToggle from '../../../MatureToggle';
import ThemeToggle from '../../_partials/ThemeToggle';
import LogoutItem from '../../_partials/LogoutItem';
import FeedbackIcon from '../../../Icons/Feedback';
import UserLink from '../../../User/Link';
import siteHeaderStyles from '../SiteHeaderMobile.scss';
import s from './UserMenu.scss';
import { BiEventType, BiLink } from '../../../biLogger';
import shortenNumber from '../../../utils/shortenNumber';
var UserMenu = /** @class */ (function (_super) {
    tslib_1.__extends(UserMenu, _super);
    function UserMenu(props) {
        var _this = _super.call(this, props) || this;
        _this.logoutItemRef = React.createRef();
        _this.toggleUserMenu = function (flag) {
            var newState = flag !== undefined ? flag : !_this.state.isUserMenuOpened;
            if (document && document.documentElement) {
                // Prevent scrolling when menu is open
                if (newState) {
                    document.body.style.overflow = 'hidden';
                    document.documentElement.style.overflow = 'hidden';
                    document.documentElement.style.height = '100%';
                    document.documentElement.style.position = 'relative';
                }
                else {
                    document.body.style.overflow = 'auto';
                    document.documentElement.style.overflow = 'auto';
                    document.documentElement.style.height = 'initial';
                    document.documentElement.style.position = 'initial';
                }
            }
            _this.setState({ isUserMenuOpened: newState });
        };
        _this.handleLogout = function () {
            _this.logoutItemRef &&
                _this.logoutItemRef.current &&
                _this.logoutItemRef.current.submit();
        };
        _this.getBuyCore = function () {
            var _a = _this.props, t = _a.t, hasCoreMembership = _a.hasCoreMembership;
            return {
                label: (React.createElement("div", { className: s['two-side-label'] },
                    React.createElement("span", null, hasCoreMembership
                        ? t('siteHeader.extendCore')
                        : t('siteHeader.buyCoreMembership')),
                    React.createElement("span", null,
                        React.createElement(CoreIconSmall, null)))),
                link: URLS.CORE_MEMBERSHIP,
                componentClass: BiLink,
                componentProps: {
                    biData: {
                        evid: BiEventType.TOP_NAV_CLICK,
                        link_name: 'coreMembership',
                        link_url: URLS.CORE_MEMBERSHIP,
                    },
                },
            };
        };
        _this.getVersionSwitcherIfApplicable = function () {
            var _a = _this.props, switchVersion = _a.switchVersion, t = _a.t, disableVersionSwitcher = _a.disableVersionSwitcher;
            if (disableVersionSwitcher) {
                return null;
            }
            return {
                label: (React.createElement("div", { className: s['two-side-label'] },
                    React.createElement("span", null, t('siteHeader.userMenu.switchVersion')),
                    React.createElement(Dino, null))),
                onClick: switchVersion,
            };
        };
        _this.getMatureToggleItem = function () {
            var _a = _this.props, t = _a.t, toggleMature = _a.toggleMature, matureContent = _a.matureContent;
            return {
                label: (React.createElement("div", { className: classnames(s['two-side-label'], s['mature-label']) },
                    React.createElement("span", null, t('siteHeader.matureContent')),
                    React.createElement(MatureToggle, { className: s['mature-toggle'], onChange: toggleMature, checked: matureContent }))),
            };
        };
        _this.getThemeSwitcherIfApplicable = function () {
            var _a = _this.props, t = _a.t, toggleTheme = _a.toggleTheme, disableThemeSwitcher = _a.disableThemeSwitcher;
            if (disableThemeSwitcher) {
                return null;
            }
            return {
                label: (React.createElement("div", { className: s['two-side-label'] },
                    React.createElement("span", null, t('siteHeader.mode')),
                    React.createElement(ThemeToggle, { className: s['theme-toggle'] }))),
                onClick: function () { return toggleTheme(); },
            };
        };
        _this.getFeedback = function () {
            var t = _this.props.t;
            return {
                label: (React.createElement("div", { className: s['two-side-label'] },
                    React.createElement("span", null, t('siteHeader.userMenu.giveUsFeedback')),
                    React.createElement(FeedbackIcon, { className: s['feedback-icon'] }))),
                link: URLS.FEEDBACK,
            };
        };
        _this.handleToggle = function () {
            _this.toggleUserMenu();
        };
        _this.state = {
            isUserMenuOpened: false,
        };
        return _this;
    }
    UserMenu.prototype.formatNumber = function (number) {
        return number > 999 ? shortenNumber(number, 0, Math.floor) : number;
    };
    UserMenu.prototype.renderAvatarPart = function () {
        var _a = this.props, currentUser = _a.currentUser, isLoggedIn = _a.isLoggedIn, noteCount = _a.noteCount, feedbackCount = _a.feedbackCount;
        var isUserMenuOpened = this.state.isUserMenuOpened;
        var notificationsCount = noteCount + feedbackCount;
        return (React.createElement(React.Fragment, null,
            isLoggedIn && (React.createElement("div", { onClick: this.handleToggle, className: classnames(s['avatar-wrapper'], isUserMenuOpened && s['with-menu-open']) },
                React.createElement(UserAvatar, { user: currentUser, className: s['avatar'], withLink: false, withTooltip: false }),
                !isUserMenuOpened && notificationsCount > 0 && (React.createElement("span", { className: siteHeaderStyles['number-label__red'] },
                    React.createElement("span", { className: classnames(siteHeaderStyles['number'], s['notification']) }, this.formatNumber(notificationsCount)))))),
            !isLoggedIn && (React.createElement("div", { className: s['user-icon-block'], onClick: this.handleToggle },
                React.createElement(UserIcon, { className: classnames(s['user-icon'], this.state.isUserMenuOpened && s['is-dark']), size: IconSize.MEDIUM, withPadding: true })))));
    };
    UserMenu.prototype.renderLoggedInMenu = function () {
        var _a = this.props, t = _a.t, currentUser = _a.currentUser, pointsCount = _a.pointsCount, noteCount = _a.noteCount, feedbackCount = _a.feedbackCount, csrfToken = _a.csrfToken, canEnableMatureContent = _a.canEnableMatureContent;
        var lastGroupItems = [
            {
                label: t('siteHeader.settings'),
                link: URLS.SETTINGS,
                className: s['settings-link'],
            },
            this.getThemeSwitcherIfApplicable(),
            canEnableMatureContent && this.getMatureToggleItem(),
            {
                label: (React.createElement(LogoutItem, { formRef: this.logoutItemRef, token: csrfToken, label: t('siteHeader.logOut') })),
                onClick: this.handleLogout,
            },
            this.getFeedback(),
            this.getVersionSwitcherIfApplicable(),
        ].filter(function (item) { return item; });
        return (React.createElement(StandardMenu, { lightText: true, className: s['user-menu'], itemClassName: s['user-menu-item'], groupClassName: s['user-menu-group'], items: [
                {
                    className: s['top-group'],
                    items: [
                        {
                            label: (React.createElement("div", { className: s['two-side-label'] },
                                React.createElement(UserLink, { user: currentUser, className: s['user-link'], showSymbol: false }),
                                this.renderAvatarPart())),
                        },
                    ],
                },
                {
                    className: s['group'],
                    items: [
                        {
                            label: (React.createElement("div", { className: s['two-side-label'] },
                                React.createElement("span", null, t('siteHeader.notes')),
                                noteCount > 0 && (React.createElement("span", { className: s['menu-item-notification'] }, this.formatNumber(noteCount))))),
                            link: URLS.NOTES,
                            componentClass: BiLink,
                            componentProps: {
                                biData: {
                                    evid: BiEventType.TOP_NAV_CLICK,
                                    link_url: URLS.NOTES,
                                    link_name: 'notes',
                                    indicator: noteCount,
                                },
                            },
                        },
                        {
                            label: (React.createElement("div", { className: s['two-side-label'] },
                                React.createElement("span", null, t('siteHeader.feedback')),
                                feedbackCount > 0 && (React.createElement("span", { className: s['menu-item-notification'] }, this.formatNumber(feedbackCount))))),
                            link: Url.feedbackLink(),
                            componentClass: BiLink,
                            componentProps: {
                                biData: {
                                    evid: BiEventType.TOP_NAV_CLICK,
                                    link_name: 'feedback',
                                    link_url: Url.feedbackLink(),
                                    indicator: feedbackCount,
                                },
                            },
                        },
                        {
                            label: 'Sta.sh',
                            link: URLS.STASH,
                            componentClass: BiLink,
                            componentProps: {
                                biData: {
                                    evid: BiEventType.TOP_NAV_CLICK,
                                    link_name: 'sta.sh',
                                    link_url: URLS.STASH,
                                },
                            },
                        },
                    ],
                },
                {
                    className: s['group'],
                    items: [
                        this.getBuyCore(),
                        {
                            label: (React.createElement("div", { className: s['two-side-label'] },
                                React.createElement("span", null, t('siteHeader.pointsBalance')),
                                React.createElement("span", null, numeral(pointsCount || 0).format('0,0')))),
                            link: URLS.POINTS,
                            componentClass: BiLink,
                            componentProps: {
                                biData: {
                                    evid: BiEventType.TOP_NAV_CLICK,
                                    link_name: 'pointsBalance',
                                    link_url: URLS.POINTS,
                                    indicator: pointsCount,
                                },
                            },
                        },
                        {
                            label: t('siteHeader.myEarnings'),
                            link: URLS.EARNINGS,
                            componentClass: BiLink,
                            componentProps: {
                                biData: {
                                    evid: BiEventType.TOP_NAV_CLICK,
                                    link_name: 'myEarnings',
                                    link_url: URLS.EARNINGS,
                                },
                            },
                        },
                        {
                            label: t('siteHeader.myOrderHistory'),
                            link: URLS.ORDERS,
                            componentClass: BiLink,
                            componentProps: {
                                biData: {
                                    evid: BiEventType.TOP_NAV_CLICK,
                                    link_name: 'orderHistory',
                                    link_url: URLS.ORDERS,
                                },
                            },
                        },
                    ],
                },
                {
                    className: s['group'],
                    items: lastGroupItems,
                },
            ] }));
    };
    UserMenu.prototype.renderLoggedOutMenu = function () {
        var t = this.props.t;
        var items = [
            {
                className: s['top-group'],
                items: [
                    {
                        label: (React.createElement("div", { className: s['two-side-label'] },
                            "t!('siteHeader.hello')",
                            this.renderAvatarPart())),
                    },
                ],
            },
            {
                className: s['group'],
                items: [
                    {
                        label: t('siteHeader.signIn'),
                        link: Url.loginLink(),
                    },
                    {
                        label: t('siteHeader.join'),
                        link: Url.joinLink(),
                    },
                    {
                        label: (React.createElement("div", { className: s['two-side-label'] },
                            React.createElement("span", null, t('siteHeader.buyCoreMembership')),
                            React.createElement("span", null,
                                React.createElement(CoreIconSmall, null)))),
                        link: URLS.CORE_MEMBERSHIP,
                    },
                    this.getThemeSwitcherIfApplicable(),
                    this.getMatureToggleItem(),
                ],
            },
        ].filter(function (item) { return item; });
        return (React.createElement(StandardMenu, { lightText: true, className: s['user-menu'], itemClassName: s['user-menu-item'], groupClassName: s['user-menu-group'], items: items }));
    };
    UserMenu.prototype.render = function () {
        var isLoggedIn = this.props.isLoggedIn;
        var isUserMenuOpened = this.state.isUserMenuOpened;
        return (React.createElement("div", { className: s['user-menu-wrapper'] },
            !this.state.isUserMenuOpened && this.renderAvatarPart(),
            React.createElement("div", { className: classnames(s['user-menu-shade'], isUserMenuOpened && s['is-active']), onClick: this.handleToggle }),
            React.createElement("div", { className: classnames(s['user-menu-list-wrapper'], isUserMenuOpened && s['is-opened']) },
                isLoggedIn && this.renderLoggedInMenu(),
                !isLoggedIn && this.renderLoggedOutMenu())));
    };
    UserMenu.prototype.handleClickOutside = function (evt) {
        if (this.state.isUserMenuOpened) {
            this.toggleUserMenu(false);
        }
    };
    return UserMenu;
}(React.Component));
export { UserMenu };
export default withTranslation()(onClickOutside(UserMenu));
//# sourceMappingURL=UserMenu.js.map